(function () {
  const brands = () => {
    let containers = document.querySelectorAll(".brands");

    containers.forEach((container) => {
      let images = container.querySelectorAll(".brands__image-wrapper");
      let infoPanels = container.querySelectorAll(".brands__info-panel");
      let links = container.querySelectorAll(".brands__placeholder");

      const transition = "opacity 0.6s ease";

      images.forEach((image, index) => {
        let isFirst = (index === 0);
        image.style.opacity = isFirst ? 1 : 0;
        image.style.zIndex = isFirst ? 1 : 0;
        image.style.transition = transition;
      });

      infoPanels.forEach((panel, index) => {
        let isFirst = (index === 0);
        panel.style.opacity = isFirst ? 1 : 0;
        panel.style.zIndex = isFirst ? 1 : 0;
        panel.style.transition = transition;
      });

      let fadeImages = (index) => {
        images.forEach((image, i) => {
          let isCurrent = (i === index);
          image.style.opacity = isCurrent ? 1 : 0;
          image.style.zIndex = isCurrent ? 1 : 0;
        });
        infoPanels.forEach((panel, i) => {
          let isCurrent = (i === index);
          panel.style.opacity = isCurrent ? 1 : 0;
          panel.style.zIndex = isCurrent ? 1 : 0;
        });
      };

      links.forEach((link, index) => link.addEventListener("mouseenter", () => fadeImages(index)));
      container.addEventListener("mouseleave", () => fadeImages(0));
    });
  };

  // Initialize the function on DOM load and section load in Shopify
  document.addEventListener("DOMContentLoaded", function () {
    brands();
    document.addEventListener("shopify:section:load", function () {
      brands();
    });
  });
})();